import { IDocumentationLog } from 'interfaces/documentation/documentations';
import { getAPI } from 'requests/api';

export const getDocumentationLogs = async ({
  documentationId
}: {
  documentationId: string | undefined;
}): Promise<IDocumentationLog[]> => {
  const { data } = await getAPI().get(
    `/admin/documentations/${documentationId}/logs`
  );

  return data;
};
